const ClubHero = ({
  title,
  subtitle,
  imageUrl,
  badge = "Amateurclub",
  kids,
}) => (
  <section className="vw-club-hero overflow-hidden rounded-3xl border border-amber-700/30 shadow-lg">
    <div
      className="relative min-h-[220px] bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(120deg, rgba(28,16,8,.88), rgba(60,30,12,.55)), url(${
          imageUrl ||
          "https://images.unsplash.com/photo-1579019163248-e7761241d85a?auto=format&fit=crop&w=1400&q=80"
        })`,
      }}
    >
      <div className="relative z-10 p-6 md:p-8 text-amber-50 max-w-2xl">
        <div className="inline-flex text-xs uppercase tracking-[0.18em] px-3 py-1 rounded-full bg-amber-200/15 border border-amber-100/30 mb-4">
          {badge}
        </div>
        <h2 className="text-3xl md:text-4xl font-black leading-tight mb-3">{title}</h2>
        {subtitle ? <p className="text-base md:text-lg opacity-90 leading-relaxed">{subtitle}</p> : null}
        {kids ? <div className="mt-5">{kids}</div> : null}
      </div>
    </div>
  </section>
);

export default ClubHero;
